<template>
  <div>
    <el-form ref="form" :rules="rules" :model="formData">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('appraise_form_label_comments') || '评价意见'"
          >
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.appraisalDescription"
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row
            v-for="(item, index) in ratingList"
            :key="index"
            style="margin-top: 5px"
          >
            <div style="display: inline-flex;justify-content: flex-start">
              <span
                >{{ item.ratingItemName }}({{ item.ratingItemNameEn }})：</span
              >
              <el-rate :max="item.ratingEnd" v-model="item.rating"></el-rate>
            </div>
          </el-row>
        </el-col>
        <el-col :span="24" v-if="createDataDisabled" style="margin-top: 30px">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Modify：{{
                formData.appraisalByName ? formData.appraisalByName : '--'
              }}
              at
              {{ formData.appraisalDate ? formData.appraisalDate : '--' }}</span
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right;margin-top: 30px">
          <el-button size="small" @click="back">{{
            $l('form_btn_return') || '返回'
          }}</el-button>
          <el-button size="small" type="primary" @click="save">{{
            $l('form_btn_save') || '保存'
          }}</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    let checkScore = (rule, value, callback) => {
      let reg = /^\d+$/
      if (!reg.test(value)) {
        return callback(new Error('请输入一个非负整数'))
      }
    }
    return {
      createDataDisabled: true,
      formData: {
        appraisalCode: '',
        scmCode: '',
        appraisalDate: '',
        appraisalBy: '',
        appraisalByName: '',
        appraisalDescription: '',
        appraisalScore: '',
        ratingList: [],
      }, // 数据
      ratingList: [],
      rules: {
        appraisalScore: [
          { required: false, validator: checkScore, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    init(formData) {
      this.formData = formData
      if (formData.type === 'add') {
        this.createDataDisabled = false
        this.$refs.form.resetFields()
        this.formData.appraisalCode = ''
        this.formData.scmCode = formData.scmCode
        this.loadRatingItemsAdd()
      } else {
        this.loadRatingItemsEdit()
        this.createDataDisabled = true
      }
    },
    // 加载表格数据-add
    loadRatingItemsAdd() {
      let param = {
        ratingItemStatusList: ['Y'],
      }
      let page = {
        pageSize: 1000,
      }
      this.$api
        .scmRatingItemsListApi({
          ...param,
          ...page,
        })
        .then((res) => {
          this.ratingList = res.body.data
        })
    },
    // 加载表格数据-edit
    loadRatingItemsEdit() {
      let param = {
        searchKey: this.formData.appraisalCode,
      }
      this.$api
        .scmRatingItemsListByAppraisalCodeApi({
          ...param,
        })
        .then((res) => {
          this.ratingList = res.body.data
        })
    },
    save() {
      this.formData.ratingList = this.ratingList
      this.$api.scmInfoAppraisalSaveApi(this.formData).then(() => {
        this.$message({
          showClose: true,
          message: '保存成功',
          type: 'success',
        })
        this.$emit('back')
        this.$refs.form.resetFields()
      })
    },
    back() {
      this.ratingList = []
      this.$emit('back')
    },
  },
}
</script>
